<kort-samling [initieltAktivt]="valgtMedlemSomSignal()">

  <!-- liste over gruppemedlemmer -->
  <kort-samling-overskrift>{{ 'Medlemmer'|translate }}</kort-samling-overskrift>
  <div class="medlemmer e2e-aktivemedlemmer">
    @for (medlem of medlemmer.medTilgangMedBrukertilknytning(); track medlem.id) {
      <medlem-kort [medlem]="medlem" [gruppe]="gruppeSomSignal()!"/>
    }
  </div>
  @if (medlemmer.medTilgangMedBrukertilknytning().length == 0) {
    <p>{{ 'Ingen aktiverte medlemmer i gruppen'|translate }}</p>
  }

  <!-- liste over invitasjoner -->
  @if (medlemmer.medTilgangUtenBrukertilknytning().length > 0 || redigeringMulig()) {
    <kort-samling-overskrift>{{ 'Invitasjoner'|translate }}</kort-samling-overskrift>
    <div class="medlemmer e2e-invitasjoner">
      @for (medlem of medlemmer.medTilgangUtenBrukertilknytning(); track medlem.id) {
        <medlem-invitasjon-kort [invitasjon]="medlem" [gruppe]="gruppeSomSignal()!"/>
      }
    </div>
    @if (redigeringMulig()) {
      @if (medlemmer.medTilgangUtenBrukertilknytning().length == 0 && medlemmer.medTilgangMedBrukertilknytning().length <= 1) {
        <tips stil="liten">
          <span class="tipskontainer">
            {{'Skriv i feltet under for å invitere et nytt medlem'|translate}}
            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="55px" height="41.333px" viewBox="0 0 55 41.333">
              <path fill="#B7B7B7" d="M2.906,3.799c21.601-0.624,39.272,14.446,46.443,34.126c0.506-0.312,1.012-0.623,1.517-0.934 c-3.603-0.91-6.975-1.999-10.332-3.607c-0.688-0.33-2.201,0.711-1.291,1.25c3.493,2.066,7.509,2.934,11,5 c0.574,0.339,1.607,0.117,1.722-0.64c0.851-5.647,0.996-11.298,1-17c0-1.05-1.962-0.786-1.963,0.129 c-0.003,5.702-0.148,11.353-1,17c0.574-0.213,1.147-0.426,1.722-0.64c-3.493-2.066-7.509-2.934-11-5 c-0.431,0.417-0.861,0.834-1.291,1.25c3.356,1.608,6.729,2.697,10.332,3.607c0.492,0.125,1.811-0.127,1.517-0.934 C43.815,16.917,25.435,1.673,3.061,2.319C1.938,2.352,1.594,3.837,2.906,3.799L2.906,3.799z"/>
            </svg>
          </span>
        </tips>
      }
      <medlem-invitasjon-opprett [gruppe]="gruppeSomSignal()!"/>
    }
  }

  <!-- liste over medlemmer uten tilgang -->
  @if (medlemmer.utenTilgangMedBrukertilknytning().length > 0 || (medlemmer.anonymiserte().length > 0 && redigeringMulig())) {
    <kort-samling-overskrift>{{ 'Medlemmer uten tilgang'|translate }}</kort-samling-overskrift>

    <!-- liste stengte medlemmer -->
    @if (medlemmer.utenTilgangMedBrukertilknytning().length > 0 && !(viserMedlemmerUtenTilgang() || valgtMedlemErUtenTilgang())) {
      <a class="visMer e2e-vis-medlemmer-uten-tilgang" (click)="viserMedlemmerUtenTilgang.set(true)">
        {{ 'Vis {antall} medlemmer med stengt tilgang'|translate:{antall: medlemmer.utenTilgangMedBrukertilknytning().length} }}
      </a>
    }
    @if (viserMedlemmerUtenTilgang() || valgtMedlemErUtenTilgang()) {
      <div class="medlemmer e2e-stengtemedlemmer">
      @for (medlem of medlemmer.utenTilgangMedBrukertilknytning(); track medlem.id) {
        <medlem-kort [medlem]="medlem" [gruppe]="gruppeSomSignal()!"/>
      }
      </div>
    }
    @if (kandidaterTilAnonymisering().length > 0) {
      <p class="kandidaterTilAnonymiseringVarsel">
        <i class="ion-android-warning std-font-warn-farge"></i>
        {{ '{antall} medlemmer har vært deaktivert i mer enn 12 måneder. Av personvernhensyn anbefaler vi at du klikker på DEAKTIVER PERMANENT for å slette medlemmets e-post og mobiltelefon.'|translate: {antall: kandidaterTilAnonymisering().length} }}
      </p>
    }

    <!-- liste anonymiserte medlemmer -->
    @if (medlemmer.anonymiserte().length > 0 && redigeringMulig() && !(viserAnonymiserteMedlemmer() || valgtMedlemErAnonymisert())) {
      <a class="visMer e2e-vis-anonymiserte-medlemmer" (click)="viserAnonymiserteMedlemmer.set(true)">
        {{ 'Vis {antall} permanent deaktivert medlemmer'|translate:{antall: medlemmer.anonymiserte().length} }}
      </a>
    }
    @if (viserAnonymiserteMedlemmer() || valgtMedlemErAnonymisert()) {
      @for (medlem of medlemmer.anonymiserte(); track medlem.id) {
        <medlem-kort [medlem]="medlem" [gruppe]="gruppeSomSignal()!" class="anonymisert"/>
      }
    }
  }
</kort-samling>
